// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".0ce5bb92f0ec8762c57d7d66a4c8d565.js";
};